'use client';

import { useUser } from '@/contexts/AuthProvider';

import { LearnMore } from '../LearnMore';

type Props = {
  children?: React.ReactNode;
};

export const AuthorizedInfo = ({ children }: Props) => {
  const user = useUser();

  return user ? children : <LearnMore />;
};
